import React, {MouseEvent, SyntheticEvent} from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'

import {Button, Variant} from '@vio/atlas/Button'
import {Flag} from '@vio/atlas/Flag'
import {cssTheme} from '@vio/atlas/themes'
import {getCountryCodeFromLanguage} from '@vio/core/src/localization/services/country'

import {SelectedElement} from '..'

interface Props {
  currency: string
  language: string
  hasCurrency?: boolean
  hasLanguage?: boolean
  onClick: (element: SelectedElement) => void
  buttonVariant?: Variant
}

const CurrencyWrapper = styled.span`
  &.--has-language {
    margin-left: ${cssTheme.layout.spacing.s300};
  }
`

const LanguageWrapper = styled.span`
  display: flex;
`

export const PreferencesLink = ({
  currency,
  language,
  hasLanguage = true,
  hasCurrency = true,
  buttonVariant = 'ghost',
  onClick
}: Props) => {
  const countryCode = getCountryCodeFromLanguage(language)

  const handleClicked = (
    event: MouseEvent | SyntheticEvent,
    element: SelectedElement
  ) => {
    event.stopPropagation()
    onClick(element)
  }

  return (
    <Button
      dataId="PreferencesSelectorButton"
      size="md"
      variant={buttonVariant}
      onClick={event =>
        handleClicked(event, hasLanguage ? 'language' : 'currency')
      }
      iconStart={
        <>
          {hasLanguage && (
            <LanguageWrapper
              data-id="language"
              data-language={language}
              onClick={event => handleClicked(event, 'language')}
            >
              <Flag countryCode={countryCode} />
            </LanguageWrapper>
          )}
          {hasCurrency && (
            <CurrencyWrapper
              data-id="currency"
              onClick={event => handleClicked(event, 'currency')}
              translate="no"
              className={cx(hasLanguage && '--has-language')}
            >
              {currency}
            </CurrencyWrapper>
          )}
        </>
      }
    />
  )
}
